import { Button } from '@/components/ui/Button';

interface ComposerQuickRepliesProps {
  suggestions: string[];
  disabled?: boolean;
  onSelect: (value: string) => void;
}

export const ComposerQuickReplies = ({
  suggestions,
  disabled = false,
  onSelect,
}: ComposerQuickRepliesProps) => {
  if (suggestions.length === 0) return null;

  return (
    <div className="mt-3 flex flex-col gap-2">
      {suggestions.map((suggestion) => (
        <Button
          key={suggestion}
          variant="outline"
          size="sm"
          disabled={disabled}
          onClick={() => onSelect(suggestion)}
          className="h-auto min-h-8 w-full justify-start whitespace-normal rounded-xl px-3 py-2 text-left leading-5"
        >
          {suggestion}
        </Button>
      ))}
    </div>
  );
};
